import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Globe } from "lucide-react";

export default function SiteSelector({ websites, selectedSite, onSelectSite }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  if (!websites.length) return null;

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 bg-dark-300 border border-dark-50 rounded-lg text-sm hover:border-copper/50 transition-colors"
      >
        <Globe size={16} className="text-copper" />
        <span className="font-medium">
          {selectedSite?.domain || "Select site"}
        </span>
        <ChevronDown
          size={14}
          className={`text-gray-400 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-1 w-64 bg-dark-300 border border-dark-50 rounded-lg shadow-xl z-50 py-1">
          {websites.map((site) => (
            <button
              key={site.id}
              onClick={() => {
                onSelectSite(site);
                setOpen(false);
              }}
              className={`w-full text-left px-4 py-2.5 text-sm hover:bg-dark-50/50 transition-colors ${
                selectedSite?.id === site.id
                  ? "text-copper bg-copper/5"
                  : "text-gray-300"
              }`}
            >
              <div className="font-medium">{site.name}</div>
              <div className="text-xs text-gray-500">{site.domain}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
